import { render, staticRenderFns } from "./RoleFilter.vue?vue&type=template&id=6507a0aa&scoped=true&"
import script from "./RoleFilter.vue?vue&type=script&lang=ts&"
export * from "./RoleFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6507a0aa",
  null
  
)

/* custom blocks */
import block0 from "./RoleFilter.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports